<template>
  <input-select
    id="religion"
    :value="value"
    name="religion"
    label="What is your religion?"
    placeholder="Prefer not to say"
    placeholder-enabled
    :options="[
      { id: 'agnostic', display_label: 'Agnostic' },
      { id: 'atheist', display_label: 'Atheist' },
      { id: 'catholic', display_label: 'Catholic' },
      { id: 'hindu', display_label: 'Hindu' },
      { id: 'jewish', display_label: 'Jewish' },
      { id: 'mormon', display_label: 'Mormon' },
      { id: 'muslim', display_label: 'Muslim' },
      { id: 'protestant', display_label: 'Protestant' },
      { id: 'unaffiliated', display_label: 'Unaffiliated' },
      { id: 'other', display_label: 'Other' }
    ]"
    @input="val => $emit('input', val)"
  />
</template>

<script>
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
    name: 'ReligionPicker',

    components: {
        InputSelect
    },

    props: {
    value: {
      type: String,
      required: true
    }
  },
};
</script>
